module.exports = __webpack_public_path__ + "static/digital tools-6cc3305971f5e3fb175263498fd504ad.jpeg";